import FormArchives from '../../DAL/FormArchives'
import { getDocs, collection } from 'firebase/firestore'
import {store} from '../utilities'

export default function readRatings(archiveId) {
  return function () {
    if (!archiveId) return
    async function fetch() {
      const formArchives = new FormArchives()
      const snap = await getDocs(collection(formArchives.docRef(archiveId), 'ratings'))
      const ratings = snap.docs.map((d) => ({id: d.id, ...d.data()}))
      store.dispatch({type: 'ratings', payload: ratings})
    }
    fetch()
  }
}
